<template>
  <ul class="notice-wrap">
    <li class="notice-item" v-for="(item, index) in noticelist" :key="'notice-item' + index" v-html="item"></li>
  </ul>
</template>
<script>
export default {
  props: {
    noticelist: {
      type: Array,
      default: () => {
        return [];
      },
      required: false
    }
  }
};
</script>
<style scoped src="@/assets/css/noticelist/noticelist.css"></style>
